<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle" id="ch00_fm01_half"><a id="page_i"></a><strong><span class="small">BROWN BOYS AND RICE QUEENS</span></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_half.vue?5dff1716